export default __webpack_public_path__ + "static/media/1852.09e9ddcc.png";